import {
	AppliersFilters,
	PatientDataTableModelArrays,
} from '../../../types/patients'
import { RootState } from '../../index'
import { createSelector } from 'reselect'

export const selectFiltersArray = (state: RootState): AppliersFilters =>
	state.appReducer.searchPatients?.appliersFilters || []

export const selectRequestPatientFilter = (state: RootState): any =>
	state.appReducer.searchPatients?.requestParamsFilter

export const selectRequestPatientFilterResult = createSelector(
	[selectFiltersArray, selectRequestPatientFilter],
	(filtersArray, requestDataPatientFilter) => {
		const cloneObject = { ...requestDataPatientFilter }
		Object.keys(cloneObject).forEach((key: any) => {
			if (key !== 'limit' && key !== 'text') {
				if (!filtersArray.find(item => item.key === key)) {
					cloneObject[key] = ''
				}
			}
		})
		return cloneObject
	}
)

export const selectHasFilters = createSelector(
	[selectFiltersArray, selectRequestPatientFilter],
	(filtersArray, requestDataPatientFilter) => {
		const cloneObject = { ...requestDataPatientFilter }
		let isCount = false
		Object.keys(cloneObject).forEach((key: any) => {
			if (key !== 'limit' && key !== 'text') {
				if (!filtersArray.find(item => item.key === key)) {
					cloneObject[key] = ''
				}
			}
		})
		Object.keys(cloneObject).forEach((key: any) => {
			if (key !== 'limit') {
				if (
					cloneObject[key] &&
					cloneObject[key] !== '' &&
					cloneObject[key].length
				) {
					isCount = true
				}
			}
		})
		return isCount
	}
)

export const selectSelectedPatients = (
	state: RootState
): PatientDataTableModelArrays =>
	state.appReducer.searchPatients?.selectedPatients || []

export const selectSelectedPatientsLength = (
	state: RootState
): number | undefined =>
	state.appReducer.searchPatients?.selectedPatients.length

export const selectTotalPatientsCount = (
	state: RootState
): number | String | undefined =>
	state.appReducer.searchPatients?.totalPatientsCount

export const selectFilteredPatientsCount = (
	state: RootState
): number | String | undefined =>
	state.appReducer.searchPatients?.filteredPatientsCount

export const selectPatientsDataArray = (
	state: RootState
): PatientDataTableModelArrays =>
	state.appReducer.searchPatients?.patientsDataArray || []

export const selectSelectedAssignPatients = (state: RootState): string[] =>
	state.appReducer.searchPatients?.selectedAssignPatients || []

export const selectIsHoldSelectedPatients = (state: RootState): boolean =>
	state.appReducer.searchPatients?.isHoldSelectedPatients || false
